<template>
  <div id="app" class="bg-gray-100 min-h-screen ">
    <Notification/>
    <ModalsComponent/>
    <router-view/>
  </div>
</template>
 
<script>
import Notification from "@/modules/home/Notification";
import ModalsComponent from "@/modules/home/ModalsComponent";

export default {  
  name: 'App',
  components: {ModalsComponent, Notification},
  data() {
    return {
      showModal: true,
    }
  },
  mounted() {

  }
}
</script>

<style>

.input {
  @apply appearance-none bg-transparent rounded-sm relative block w-full px-3 py-2 border border-gray-300 text-gray-900 leading-5
}

.reportrange-text {
  height: 100% !important;
  padding: 2px 10px !important;
}

body {
  font-family: Roboto, "IBM Plex Sans", Helvetica Neue, Helvetica, Arial, sans-serif;
  /*background-color: #edf2f7 !important;*/
  font-size: 13px;
}

a:hover {
  text-decoration: none !important;
  color: #005cbf;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}


label {
  font-size: 11px !important;
  letter-spacing: .5px;
  text-transform: uppercase;
  -webkit-transition: color .2s linear 0s;
  transition: color .2s linear 0s;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 500;
}

thead {
  font-size: 12px !important;
  text-transform: uppercase;
  font-weight: 700 !important;
  color: #626262 !important;
}


</style>
